import { Group, Stack } from "@mantine/core";
import LeadsSearchMobile from "./LeadsSearchMobile";
import LeadsFilterMobile from "./LeadsFilterMobile";
import ReloadButton from "../../controller/ReloadButton";
import LeadsColumnChangerMobile from "./LeadsColumnChangerMobile";
import LeadsQuickNewFilterMobile from "./LeadsQuickNewFilterMobile";

const ControllerMobile = () => {
  return (
    <Stack>
      <LeadsSearchMobile />

      <Group gap={0} mb={8}>
        <LeadsColumnChangerMobile />

        <LeadsFilterMobile />

        <LeadsQuickNewFilterMobile />

        <ReloadButton isMobile />
      </Group>
    </Stack>
  );
};

export default ControllerMobile;
